import reactTextareaAutosize from 'react-textarea-autosize';

import { Switch } from '@frontend/components/ui/switch';
import { Textarea } from '@frontend/components/ui/textarea';

export function CustomLabelField({
  title,
  description,
  isOverridden,
  value,
  onToggle,
  onValueChange,
  placeholder,
  isReadOnly = false,
}: {
  title: string;
  description: string;
  isOverridden: boolean;
  value: string;
  onToggle: (enabled: boolean) => void;
  onValueChange: (value: string) => void;
  placeholder?: string;
  isReadOnly?: boolean;
}) {
  return (
    <div className="mb-6">
      <div className="mb-2 flex items-center justify-between">
        <div>
          <h4 className="mb-1 text-xs font-semibold">{title}</h4>
          <p className="text-xs text-gray-500">{description}</p>
        </div>
        <Switch
          checked={isOverridden}
          disabled={isReadOnly}
          onCheckedChange={(checked) => !isReadOnly && onToggle(checked)}
        />
      </div>

      {isOverridden && (
        <div className="mt-2">
          <Textarea
            // @ts-expect-error - reactTextareaAutosize typing issue
            as={reactTextareaAutosize}
            value={value}
            className="text-sm leading-[21px]"
            minRows={2}
            disabled={isReadOnly}
            onChange={(e) => !isReadOnly && onValueChange(e.target.value)}
            placeholder={placeholder}
          />
        </div>
      )}
    </div>
  );
}
